import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import click from './sounds/shortclick.mp3';

export default function Meters() {
    const [dev, setDev] = useState([]);
    const [displaydev, setDisplayDev] = useState([]);
    const [powerData, setPowerData] = useState([]);
    const [waterData, setWaterData] = useState([]);
    const [solarData, setSolarData] = useState([]);
    const [weatherData, setWeatherData] = useState([]);
    const [selectedDeviceType, setSelectedDeviceType] = useState('power');
    const [selectedDeviceId, setSelectedDeviceId] = useState(null);
    const [retry, setRetry] = useState(false);
    const [hoveredCell, setHoveredCell] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState(1);

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    // Handle button click for IoT devices
    function handleClick(e) {
        playClickSound();
        setSelectedChannel(e);
        setSelectedDeviceType('iot');
        let filteredDev = dev.filter(d => d.channel === e);
        setDisplayDev(filteredDev);
    };

    // Handle device type selection
    function handleDeviceTypeClick(type) {
        playClickSound();
        setSelectedDeviceType(type);
        setSelectedDeviceId(null);
    };

    // Handle individual device selection
    function handleDeviceSelect(deviceId) {
        playClickSound();
        setSelectedDeviceId(deviceId);
    };

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Fetch IoT devices data
        const getIoTData = async () => {
            await httpClient.get('/api/meters')
                .then((response) => {
                    const deviceDetails = response.data.map((item) => ({
                        id: item.deviceId,
                        deviceName: item.deviceName,
                        deviceEui: item.deviceEui,
                        label: item.label,
                        status: item.status,
                        logic: item.type,
                        data_type: item.dataType,
                        alive: item.alive,
                        data: item.data,
                        channel: item.channel
                    }));

                    let filteredDev = deviceDetails.filter(d => d.channel === 1);
                    setDisplayDev(filteredDev);
                    setDev(deviceDetails);
                })
                .catch(error => {
                    console.error(error);
                    setRetry(true);
                });
        };

        // Fetch Power Meter Data
        const getPowerData = async () => {
            await httpClient.get('/api/meters/power_meter_data')
                .then((response) => {
                    setPowerData(response.data);
                })
                .catch(error => {
                    console.error('Error fetching power data:', error);
                });
        };

        // Fetch Water Meter Data
        const getWaterData = async () => {
            await httpClient.get('/api/meters/water_meter_data')
                .then((response) => {
                    setWaterData(response.data);
                })
                .catch(error => {
                    console.error('Error fetching water data:', error);
                });
        };

        // Fetch Solar Panel Data
        const getSolarData = async () => {
            await httpClient.get('/api/meters/solar_panel_data')
                .then((response) => {
                    setSolarData(response.data);
                })
                .catch(error => {
                    console.error('Error fetching solar data:', error);
                });
        };

        // Fetch Weather Station Data
        const getWeatherData = async () => {
            await httpClient.get('/api/meters/weather_station_data')
                .then((response) => {
                    setWeatherData(response.data);
                })
                .catch(error => {
                    console.error('Error fetching weather data:', error);
                });
        };

        getIoTData();
        getPowerData();
        getWaterData();
        getSolarData();
        getWeatherData();

        // Set up polling for real-time data updates
        const interval = setInterval(() => {
            getPowerData();
            getWaterData();
            getSolarData();
            getWeatherData();
        }, 30000); // Update every 30 seconds

        return () => clearInterval(interval);
    }, [retry]);

    // IoT Devices List Component
    function IoTDeviceList() {
        return (
            <div>
                <tr className="row">
                    {Array.isArray(displaydev) &&
                        displaydev.map((product, index) => (
                            <td key={index} className="cellstyle" style={{
                                fontSize: "16px",
                                overflow: "hidden",
                                color: "#f7f4ef",
                                backgroundColor: "#525252",
                                animation: 'slideIn 0.5s ease-out forwards',
                                animationDelay: `${index * 0.1}s`,
                                opacity: 0,
                            }} >
                                <table>
                                    <tr style={{ height: "85px" }}>{product.deviceName}</tr>
                                    <tr>
                                        <div style={{ fontSize: "18px", overflow: "hidden", fontWeight: "bold", color: "green" }}>
                                            <div className="statusstyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", color: "#f5f0e9", backgroundColor: hoveredCell === index ? "#0009df" : "#525252" }}>
                                                {product.data} {product.label}
                                            </div>
                                        </div>
                                    </tr>
                                </table>
                            </td>
                        ))
                    }
                </tr>
            </div>
        );
    }

    // Power Meter Data Component
    function PowerMeterList() {
        const devices = selectedDeviceId
            ? powerData.filter(device => device.deviceId === selectedDeviceId)
            : powerData;

        return (
            <div style={{ color: 'white', padding: '10px' }}>
                <h3>電力錶數據 (Power Meter Data)</h3>
                <div style={{ marginBottom: '10px' }}>
                    <select
                        onChange={(e) => handleDeviceSelect(e.target.value ? parseInt(e.target.value) : null)}
                        value={selectedDeviceId || ''}
                        style={{ padding: '5px', marginRight: '10px' }}
                    >
                        <option value="">所有設備 (All Devices)</option>
                        {Array.from(new Set(powerData.map(d => d.deviceId))).map(id => (
                            <option key={id} value={id}>設備 ID: {id}</option>
                        ))}
                    </select>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#333' }}>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>設備 ID</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>時間</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>總用電量 (kWh)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>最大需求 (kW)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L1電流 (A)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L2電流 (A)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L3電流 (A)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>N電流 (A)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L1-N電壓 (V)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L2-N電壓 (V)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>L3-N電壓 (V)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>總功率因數 </th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>總諧波失真 (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {devices.map((device, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#444' : '#555' }}>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.deviceId}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>
                                    {new Date(device.timestamp).toLocaleString('zh-TW')}
                                </td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.totalEnergyConsumption?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.maximumDemand?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.currentL1?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.currentL2?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.currentL3?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.currentN?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.voltageL1n?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.voltageL2n?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.voltageL3n?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.totalPower?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.totalHarmonicsDistortion?.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    // Water Meter Data Component
    function WaterMeterList() {
        return (
            <div style={{ color: 'white', padding: '10px' }}>
                <h3>水錶數據 (Water Meter Data)</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#333' }}>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>設備 ID</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>時間</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>累計用水量 (m³)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>流速 (m³/h)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {waterData.map((device, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#444' : '#555' }}>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.deviceId}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>
                                    {new Date(device.timestamp).toLocaleString('zh-TW')}
                                </td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.accumulatedWaterConsumption?.toFixed(2)}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.flowRate?.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    // Solar Panel Data Component
    function SolarPanelList() {
        return (
            <div style={{ color: 'white', padding: '10px' }}>
                <h3>太陽能板數據 (Solar Panel Data)</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#333' }}>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>設備 ID</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>時間</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>總發電量 (kWh)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {solarData.map((device, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#444' : '#555' }}>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.deviceId}</td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>
                                    {new Date(device.timestamp).toLocaleString('zh-TW')}
                                </td>
                                <td style={{ border: '1px solid #555', padding: '8px' }}>{device.totalEnergyGeneration?.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    // Weather Station Data Component
    function WeatherStationList() {
        return (
            <div style={{ color: 'white', padding: '10px' }}>
                <h3>氣象站數據 (Weather Station Data)</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#333' }}>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>設備 ID</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>時間</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>室外溫度 (°C)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>室外濕度 (%)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>風速 (m/s)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>太陽輻射 (W/m²)</th>
                            <th style={{ border: '1px solid #555', padding: '8px' }}>UV指數</th>
                        </tr>
                    </thead>
                    <tbody>
                        {weatherData.map((device, index) => {
                            // Divide by 10 and format with one decimal place
                            const temperature = device.pvPanelTemperature != null
                                ? (device.pvPanelTemperature / 10).toFixed(1)
                                : 'N/A';
                            const uvIndex = device.uvIndex != null
                                ? (device.uvIndex / 10).toFixed(1)
                                : 'N/A';

                            return (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#444' : '#555' }}>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{device.deviceId}</td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>
                                        {new Date(device.timestamp).toLocaleString('zh-TW')}
                                    </td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{temperature}</td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{device.outsideHumidity?.toFixed(2)}</td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{device.windspeed?.toFixed(2)}</td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{device.solarRadiation?.toFixed(2)}</td>
                                    <td style={{ border: '1px solid #555', padding: '8px' }}>{uvIndex}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    // Main Content Renderer
    function renderContent() {
        switch (selectedDeviceType) {
            case 'iot':
                return <IoTDeviceList />;
            case 'power':
                return <PowerMeterList />;
            case 'water':
                return <WaterMeterList />;
            case 'solar':
                return <SolarPanelList />;
            case 'weather':
                return <WeatherStationList />;
            default:
                return <IoTDeviceList />;
        }
    }

    return (
        <div className="containerstyle">
            <table>
                <td>
                    <div>
                        <table>
                            <tr>
                                <td style={{ verticalAlign: "top", width: "15%", height: "13.4rem" }}>
                                    <div>
                                        <div className="meterlabelstyle" style={{ fontSize: "22px", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#6f4f4f" }}>
                                            物聯網應用
                                        </div>
                                        <div className="meterlabelstyle" style={{ fontSize: "18px", fontWeight: "bold", color: selectedDeviceType === 'power' ? "#202020" : "#f5f1eb", backgroundColor: selectedDeviceType === 'power' ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleDeviceTypeClick('power')}>
                                            斑蝶樓電力錶數據
                                        </div>
                                        <div className="meterlabelstyle" style={{ fontSize: "18px", fontWeight: "bold", color: selectedDeviceType === 'water' ? "#202020" : "#f5f1eb", backgroundColor: selectedDeviceType === 'water' ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleDeviceTypeClick('water')}>
                                            斑蝶樓水錶數據
                                        </div>
                                        <div className="meterlabelstyle" style={{ fontSize: "18px", fontWeight: "bold", color: selectedDeviceType === 'solar' ? "#202020" : "#f5f1eb", backgroundColor: selectedDeviceType === 'solar' ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleDeviceTypeClick('solar')}>
                                            斑蝶樓太陽能數據
                                        </div>
                                        <div className="meterlabelstyle" style={{ fontSize: "18px", fontWeight: "bold", color: selectedDeviceType === 'weather' ? "#202020" : "#f5f1eb", backgroundColor: selectedDeviceType === 'weather' ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleDeviceTypeClick('weather')}>
                                            斑蝶樓氣象站數據
                                        </div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <div style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px", maxHeight: "80vh", overflow: "auto" }}>
                                        {renderContent()}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );
}